import Tables from 'src/class/Tables';
import i18n from 'src/i18n';
import { formatConversionFactor } from './formatConversionFactor';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('production.box_typeof'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'box_pallet.pallet',
      label: i18n.t('production.stowage_typeof'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'conversion_factor',
      label: i18n.t('common_words.conversion_factor'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: (row) => formatConversionFactor(row.conversion_factor),
    },
    {
      prop: 'tara_weight_label',
      label: i18n.t('production.tara'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'min_weight',
      label: i18n.t('production.min_weight'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'max_weight',
      label: i18n.t('production.max_weight'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    }
  ];

  return { Table };
};

export default configTable;
